"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templating = void 0;
const templating = (containerId, templateElm) => {
    const container = document.getElementById(containerId);
    if (!container) {
        throw new Error(`Container not defined in DOM, ${containerId}`);
    }
    const getTemplate = (id) => {
        const template = templateElm !== null && templateElm !== void 0 ? templateElm : document.getElementById(id);
        if (!template) {
            throw new Error('Template not found');
        }
        return template.content.cloneNode(true);
    };
    return {
        bindObject: (templateId, templateModels) => {
            const template = getTemplate(templateId);
            const fragment = document.createDocumentFragment(); // Helps minimize reflows
            templateModels.forEach((model) => {
                const element = template.querySelector(`.${model.className}`);
                if (!element) {
                    console.error(`Element not found: classname = ${model.className}`);
                    return;
                }
                else {
                    if (model.attributeName) {
                        element.setAttribute(model.attributeName, model.content);
                    }
                    else {
                        element.textContent = model.content;
                    }
                }
            });
            fragment.appendChild(template);
            container.appendChild(fragment);
        },
        addEvent: () => { },
    };
};
exports.templating = templating;
